export const VALIDATION_ACTION = {
  HARD_STOP: "HARD_STOP",
  ENTER_REASON_STOP: "ENTER_REASON_STOP",
  YES_NO_CONTINUE: "YES_NO_CONTINUE",
};

const normalize = (v) => (typeof v === "string" ? v.trim().toLowerCase() : "");

export const mapValidationAction = (rawAction) => {
  const a = normalize(rawAction);

  // Swagger enums
  if (a === "hard stop") return VALIDATION_ACTION.HARD_STOP;
  if (a === "enter reason stop") return VALIDATION_ACTION.ENTER_REASON_STOP;
  if (a === "yes/no (continue)") return VALIDATION_ACTION.YES_NO_CONTINUE;

  // Backend / client variants
  if (a === "hard_stop" || a === "hardstop") return VALIDATION_ACTION.HARD_STOP;
  if (a === "enter_reason_stop" || a === "enterreasonstop")
    return VALIDATION_ACTION.ENTER_REASON_STOP;
  if (a === "yes_no_continue" || a === "yesnocontinue")
    return VALIDATION_ACTION.YES_NO_CONTINUE;

  return null;
};

export const hasHardStop = (validations) =>
  Array.isArray(validations) &&
  validations.some((v) => mapValidationAction(v?.action) === VALIDATION_ACTION.HARD_STOP);

